
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","xmlns":"http://www.w3.org/2000/svg","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"6.5","cy":"5","r":"2.75","stroke":"currentColor","stroke-width":"1.4"}}),_c('path',{attrs:{"d":"M1.75 13.5c0-2.2 2.1-3.75 4.75-3.75 1.05 0 2 .24 2.8.67","stroke":"currentColor","stroke-width":"1.4","stroke-linecap":"round"}}),_c('path',{attrs:{"d":"M10.5 12.1l1.3 1.3 2.45-2.6","stroke":"currentColor","stroke-width":"1.4","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    